var map = {
	"./compass.js": [
		38,
		0,
		10
	],
	"./gauge.js": [
		39,
		0,
		11
	],
	"./jqgrid.js": [
		30,
		1,
		5,
		0,
		12
	],
	"./map.js": [
		31,
		6,
		0,
		13
	],
	"./panel.js": [
		32,
		0,
		14
	],
	"./progressbar.js": [
		33,
		0,
		15
	],
	"./status.js": [
		34,
		7,
		0,
		16
	],
	"./table.js": [
		35,
		0,
		17
	],
	"./thermometer.js": [
		40,
		0,
		18
	],
	"./timechart.js": [
		36,
		1,
		8,
		0,
		19
	],
	"./windrose.js": [
		37,
		9,
		0,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 10;
module.exports = webpackAsyncContext;